// import React from 'react'
// import { FaUsers } from "react-icons/fa";
// import { GrCube } from "react-icons/gr";
// import { FaHeadphonesSimple } from "react-icons/fa6";
// import { BsCardList } from "react-icons/bs";

// const CustomberList = () => {
//   return (
// <div className="page-content">
//   {/* Start Container Fluid */}
//   <div className="container-fluid">
//     {/* ========== Page Title Start ========== */}
//     <div className="row">
//       <div className="col-12">
//         <div className="page-title-box">
//           <h4 className="mb-0 fw-semibold">Customer List</h4>
//           <ol className="breadcrumb mb-0">
//             <li className="breadcrumb-item">
//               <a href="javascript: void(0);">Customer</a>
//             </li>
//             <li className="breadcrumb-item active">Customer List</li>
//           </ol>
//         </div>
//       </div>
//     </div>
//     {/* ========== Page Title End ========== */}
//     <div className="row">
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center gap-2 mb-3">
//               <div className="avatar-md bg-primary bg-opacity-10 rounded">
//               <FaUsers 
//                   className="fs-32 text-primary avatar-title"
//                 />
//               </div>
//               <div>
//                 <h4 className="mb-0">All Customers</h4>
//               </div>
//             </div>
//             <div className="d-flex align-items-center justify-content-between">
//               <p className="text-muted fw-medium fs-22 mb-0">+22.63k</p>
//               <div>
//                 <span className="badge text-success bg-success-subtle fs-12">
//                   <i className="bx bx-up-arrow-alt" />
//                   34.4%
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center gap-2 mb-3">
//               <div className="avatar-md bg-primary bg-opacity-10 rounded">
//              <GrCube 
//                   className="fs-32 text-primary avatar-title"
//                 />
//               </div>
//               <div>
//                 <h4 className="mb-0">Orders</h4>
//               </div>
//             </div>
//             <div className="d-flex align-items-center justify-content-between">
//               <p className="text-muted fw-medium fs-22 mb-0">+4.5k</p>
//               <div>
//                 <span className="badge text-danger bg-danger-subtle fs-12">
//                   <i className="bx bx-down-arrow-alt" />
//                   8.1%
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center gap-2 mb-3">
//               <div className="avatar-md bg-primary bg-opacity-10 rounded">
//             <FaHeadphonesSimple 
//                   className="fs-32 text-primary avatar-title"
//                 />
//               </div>
//               <div>
//                 <h4 className="mb-0">Services Request</h4>
//               </div>
//             </div>
//             <div className="d-flex align-items-center justify-content-between">
//               <p className="text-muted fw-medium fs-22 mb-0">+1.03k</p>
//               <div>
//                 <span className="badge text-success bg-success-subtle fs-12">
//                   <i className="bx bx-up-arrow-alt" />
//                   12.6%
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="col-md-6 col-xl-3">
//         <div className="card">
//           <div className="card-body">
//             <div className="d-flex align-items-center gap-2 mb-3">
//               <div className="avatar-md bg-primary bg-opacity-10 rounded">
//                <BsCardList 
//                   className="fs-32 text-primary avatar-title"
//                 />
//               </div>
//               <div>
//                 <h4 className="mb-0">Invoice &amp; Payment</h4>
//               </div>
//             </div>
//             <div className="d-flex align-items-center justify-content-between">
//               <p className="text-muted fw-medium fs-22 mb-0">$38,908.00</p>
//               <div>
//                 <span className="badge text-success bg-success-subtle fs-12">
//                   <i className="bx bx-up-arrow-alt" />
//                   45.9%
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//     <div className="row">
//       <div className="col-xl-12">
//         <div className="card">
//           <div className="d-flex card-header justify-content-between align-items-center">
//             <div>
//               <h4 className="card-title">All Customers List</h4>
//             </div>
//             <div className="dropdown">
//               <a
//                 href="#"
//                 className="dropdown-toggle btn btn-sm btn-outline-light rounded"
//                 data-bs-toggle="dropdown"
//                 aria-expanded="false"
//               >
//                 This Month
//               </a>
//               <div className="dropdown-menu dropdown-menu-end">
//                 {/* item*/}
//                 <a href="#!" className="dropdown-item">
//                   Download
//                 </a>
//                 {/* item*/}
//                 <a href="#!" className="dropdown-item">
//                   Export
//                 </a>
//                 {/* item*/}
//                 <a href="#!" className="dropdown-item">
//                   Import
//                 </a>
//               </div>
//             </div>
//           </div>
//           <div>
//             <div className="table-responsive">
//               <table className="table align-middle mb-0 table-hover table-centered">
//                 <thead className="bg-light-subtle">
//                   <tr>
//                     <th style={{ width: 20 }}>
//                       <div className="form-check ms-1 fs-16">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck1"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck1"
//                         />
//                       </div>
//                     </th>
//                     <th>Customer Name</th>
//                     <th>Invoice ID</th>
//                     <th>Status</th>
//                     <th>Total Amount</th>
//                     <th>Amount Due</th>
//                     <th>Due Date</th>
//                     <th>Payment Method</th>
//                     <th>Status</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td>
//                       <div className="form-check ms-1 fs-16">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck2"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck2"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-5.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       Michael A. Miner
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV2540
//                       </a>{" "}
//                     </td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                         Completed
//                       </span>{" "}
//                     </td>
//                     <td> $4,521 </td>
//                     <td> $8,901 </td>
//                     <td> 07 Jan, 2023</td>
//                     <td> Mastercard </td>
//                       <td>
//                       {" "}
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                        Verified
//                       </span>{" "}
//                     </td>
//                     <td>
//                          <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check ms-1 fs-16">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck3"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck3"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-3.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       Theresa T. Brose
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV3924
//                       </a>{" "}
//                     </td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-danger-subtle text-danger px-2 py-1">
//                         Cancel
//                       </span>{" "}
//                     </td>
//                     <td> $7,836 </td>
//                     <td> $9,902 </td>
//                     <td> 03 Dec, 2023</td>
//                     <td> Visa </td>
//                      <td>
//                       {" "}
//                       <span className="badge bg-danger-subtle text-danger px-2 py-1">
//                         Defaulter
//                       </span>{" "}
//                     </td>
//                     <td>
//                          <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check ms-1 fs-16">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck4"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck4"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-1.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       James L. Erickson
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV5032
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                         Completed
//                       </span>
//                     </td>
//                     <td> $1,347 </td>
//                     <td> $6,718 </td>
//                     <td> 28 Sep, 2023 </td>
//                     <td> Paypal </td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                        Verified
//                       </span>{" "}
//                     </td>
//                     <td>
//                          <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check ms-1 fs-16">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck5"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck5"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-5.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       Lily W. Wilson
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV1695
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <span className="badge bg-primary-subtle text-primary py-1 px-2">
//                         Pending
//                       </span>
//                     </td>
//                     <td> $9,457 </td>
//                     <td> $3,928 </td>
//                     <td>10 Aug, 2023</td>
//                     <td> Mastercard</td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                        Verified
//                       </span>{" "}
//                     </td>
//                     <td>
//                          <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check ms-1 fs-16">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck6"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck6"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-6.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       Sarah M. Brooks
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV8473
//                       </a>{" "}
//                     </td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-danger-subtle text-danger px-2 py-1 ">
//                         Cancel
//                       </span>
//                     </td>
//                     <td> $4,214</td>
//                     <td> $9,814 </td>
//                     <td> 22 May, 2023 </td>
//                     <td> Visa</td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-danger-subtle text-danger px-2 py-1">
//                         Defaulter
//                       </span>{" "}
//                     </td>
//                     <td>
//                          <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check ms-1 fs-16">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck7"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck7"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-7.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />{" "}
//                       Joe K. Hall
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV2150
//                       </a>{" "}
//                     </td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                         Completed
//                       </span>{" "}
//                     </td>
//                     <td>$2,513</td>
//                     <td> $5,891 </td>
//                     <td>15 Mar, 2023</td>
//                     <td> Paypal </td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-danger-subtle text-danger px-2 py-1">
//                         Defaulter
//                       </span>{" "}
//                     </td>
//                     <td>
//                          <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check ms-1 fs-16">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck7"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck7"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-5.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />
//                       Ralph Hueber
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV5636
//                       </a>{" "}
//                     </td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                         Completed
//                       </span>{" "}
//                     </td>
//                     <td>$3,103</td>
//                     <td> $8,415 </td>
//                     <td>15 Mar, 2023</td>
//                     <td> Visa </td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                        Verified
//                       </span>{" "}
//                     </td>
//                     <td>
//                          <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check ms-1 fs-16">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck7"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck7"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-1.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />
//                       Sarah Drescher
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV2940
//                       </a>{" "}
//                     </td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-success-subtle text-success py-1 px-2">
//                         Completed
//                       </span>{" "}
//                     </td>
//                     <td>$2,416</td>
//                     <td> $7,715 </td>
//                     <td>15 Mar, 2023</td>
//                     <td> Mastercard </td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-danger-subtle text-danger px-2 py-1">
//                         Defaulter
//                       </span>{" "}
//                     </td>
//                     <td>
//                          <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>
//                       <div className="form-check ms-1 fs-16">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customCheck7"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customCheck7"
//                         >
//                           &nbsp;
//                         </label>
//                       </div>
//                     </td>
//                     <td>
//                       <img
//                         src="/images/users/avatar-3.jpg"
//                         className="avatar-sm rounded-circle me-2"
//                         alt="..."
//                       />
//                       Leonie Meister
//                     </td>
//                     <td>
//                       <a href="javascript: void(0);" className="text-body">
//                         #INV9027
//                       </a>{" "}
//                     </td>
//                     <td>
//                       <span className="badge bg-primary-subtle text-primary py-1 px-2">
//                         Pending
//                       </span>
//                     </td>
//                     <td>$1,367</td>
//                     <td> $3,651 </td>
//                     <td>15 Mar, 2023 </td>
//                     <td> Paypal </td>
//                     <td>
//                       {" "}
//                       <span className="badge bg-danger-subtle text-danger px-2 py-1">
//                         Defaulter
//                       </span>{" "}
//                     </td>
//                     <td>
//                          <div className="d-flex gap-2">
//                         <a href="#!" className="btn btn-light btn-sm">
//                           <i className="fa-solid fa-eye align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-primary btn-sm">
//                           <i class="fa-solid fa-pencil align-middle fs-18"></i>
//                         </a>
//                         <a href="#!" className="btn btn-soft-danger btn-sm">
//                           <i class="fa-solid fa-trash align-middle fs-18"></i>
//                         </a>
//                       </div>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//             {/* end table-responsive */}
//           </div>
//           <div className="card-footer border-top">
//             <nav aria-label="Page navigation example">
//               <ul className="pagination justify-content-end mb-0">
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     Previous
//                   </a>
//                 </li>
//                 <li className="page-item active">
//                   <a className="page-link" href="javascript:void(0);">
//                     1
//                   </a>
//                 </li>
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     2
//                   </a>
//                 </li>
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     3
//                   </a>
//                 </li>
//                 <li className="page-item">
//                   <a className="page-link" href="javascript:void(0);">
//                     Next
//                   </a>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
//   {/* End Container Fluid */}
//   {/* ========== Footer Start ========== */}
//   <footer className="footer">
//     <div className="container-fluid">
//       <div className="row">
//         <div className="col-12 text-center">
//           © Venton. Crafted by{" "}
//           <iconify-icon
//             icon="iconamoon:heart-duotone"
//             className="fs-18 align-middle text-danger"
//           />{" "}
//           <a href="" className="fw-bold footer-text" target="_blank">
//             Techzaa
//           </a>
//         </div>
//       </div>
//     </div>
//   </footer>
//   {/* ========== Footer End ========== */}
// </div>

//   )
// }

// export default CustomberList


import React, { useState, useEffect } from 'react'
import { FaUsers } from "react-icons/fa";
import { GrCube } from "react-icons/gr";
import { FaHeadphonesSimple } from "react-icons/fa6";
import { BsCardList } from "react-icons/bs";
import { Link } from 'react-router-dom';

const CustomerList = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [rejectingId, setRejectingId] = useState(null);
  const [approvingId, setApprovingId] = useState(null);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [stats, setStats] = useState({
    totalCustomers: 0,
    activeCustomers: 0,
    inactiveCustomers: 0
  });

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await fetch('https://cyberathon.com/multivendor/index.php/Api/Master_controller/user_list');
      const result = await response.json();

      if (result.status && result.success === "1") {
        setCustomers(result.data);

        // Calculate statistics
        const total = result.data.length;
        const active = result.data.filter(user => user.status === 'active').length;
        const inactive = total - active;

        setStats({
          totalCustomers: total,
          activeCustomers: active,
          inactiveCustomers: inactive
        });
      } else {
        setError(result.message || 'Failed to fetch customers');
      }
    } catch (err) {
      setError('Error fetching customer data: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const getStatusBadge = (status) => {
    if (status === 'active') {
      return <span className="badge bg-success-subtle text-success py-1 px-2">Active</span>;
    }
    return <span className="badge bg-danger-subtle text-danger px-2 py-1">Inactive</span>;
  };

  const getAvatarPlaceholder = (name) => {
    // Generate a consistent avatar number based on name
    const index = name ? (name.charCodeAt(0) % 7) + 1 : 1;
    return `/images/users/avatar-${index}.jpg`;
  };


  const updateUserStatus = async (user_id, status) => {
  const confirmMsg =
    status === "active"
      ? "Are you sure you want to activate this user?"
      : "Are you sure you want to deactivate this user?";

  if (!window.confirm(confirmMsg)) return;

  try {
    setApprovingId(user_id);

    const response = await fetch(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_user",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: user_id,
          status: status,
        }),
      }
    );

    const result = await response.json();
    console.log("Update user response:", result);

    if (result.status === "true" || result.status === true) {
      // ✅ update local state
      const updatedCustomers = customers.map((user) =>
        user.user_id === user_id
          ? { ...user, status: status }
          : user
      );

      setCustomers(updatedCustomers);
      alert(`User ${status === "active" ? "activated" : "deactivated"} successfully`);
    } else {
      alert(result.message || "Failed to update user status");
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong");
  } finally {
    setApprovingId(null);
  }
};


  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Customer List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Customer</a>
                </li>
                <li className="breadcrumb-item active">Customer List</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}

        <div className="row">
          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div className="avatar-md bg-primary bg-opacity-10 rounded">
                    <FaUsers className="fs-32 text-primary avatar-title" />
                  </div>
                  <div>
                    <h4 className="mb-0">All Customers</h4>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-muted fw-medium fs-22 mb-0">+{stats.totalCustomers}</p>
                  <div>
                    <span className="badge text-success bg-success-subtle fs-12">
                      <i className="bx bx-up-arrow-alt" />
                      100%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div className="avatar-md bg-primary bg-opacity-10 rounded">
                    <GrCube className="fs-32 text-primary avatar-title" />
                  </div>
                  <div>
                    <h4 className="mb-0">Active Users</h4>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-muted fw-medium fs-22 mb-0">+{stats.activeCustomers}</p>
                  <div>
                    <span className="badge text-success bg-success-subtle fs-12">
                      <i className="bx bx-up-arrow-alt" />
                      {stats.totalCustomers > 0 ? ((stats.activeCustomers / stats.totalCustomers) * 100).toFixed(1) : 0}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div className="avatar-md bg-primary bg-opacity-10 rounded">
                    <FaHeadphonesSimple className="fs-32 text-primary avatar-title" />
                  </div>
                  <div>
                    <h4 className="mb-0">Services Request</h4>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-muted fw-medium fs-22 mb-0">+1.03k</p>
                  <div>
                    <span className="badge text-success bg-success-subtle fs-12">
                      <i className="bx bx-up-arrow-alt" />
                      12.6%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <div className="avatar-md bg-primary bg-opacity-10 rounded">
                    <BsCardList className="fs-32 text-primary avatar-title" />
                  </div>
                  <div>
                    <h4 className="mb-0">Invoice &amp; Payment</h4>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <p className="text-muted fw-medium fs-22 mb-0">$38,908.00</p>
                  <div>
                    <span className="badge text-success bg-success-subtle fs-12">
                      <i className="bx bx-up-arrow-alt" />
                      45.9%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="d-flex card-header justify-content-between align-items-center">
                <div>
                  <h4 className="card-title">All Customers List</h4>
                </div>
                <div className="dropdown">
                  <a
                    href="#"
                    className="dropdown-toggle btn btn-sm btn-outline-light rounded"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    This Month
                  </a>
                  <div className="dropdown-menu dropdown-menu-end">
                    <a href="#!" className="dropdown-item">Download</a>
                    <a href="#!" className="dropdown-item">Export</a>
                    <a href="#!" className="dropdown-item">Import</a>
                  </div>
                </div>
              </div>

              <div>
                <div className="table-responsive">
                  {loading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : error ? (
                    <div className="alert alert-danger m-3" role="alert">
                      {error}
                    </div>
                  ) : (
                    <table className="table align-middle mb-0 table-hover table-centered">
                      <thead className="bg-light-subtle">
                        <tr>
                          <th style={{ width: 20 }}>
                            <div className="form-check ms-1 fs-16">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="customCheck1"
                              />
                              <label className="form-check-label" htmlFor="customCheck1" />
                            </div>
                          </th>
                          <th>Customer Name</th>
                          <th>User ID</th>
                          <th>Email</th>
                          <th>Mobile</th>
                          <th>City</th>
                          <th>State</th>
                          <th>Joined Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customers.map((customer, index) => (
                          <tr key={customer.user_id}>
                            <td>
                              <div className="form-check ms-1 fs-16">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`customCheck${index + 2}`}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`customCheck${index + 2}`}
                                >
                                  &nbsp;
                                </label>
                              </div>
                            </td>
                            <td>
                              <img
                                src={getAvatarPlaceholder(customer.name)}
                                className="avatar-sm rounded-circle me-2"
                                alt="..."
                              />{" "}
                              {customer.name}
                            </td>
                            <td>
                              <a href="javascript: void(0);" className="text-body">
                                #{customer.user_id}
                              </a>
                            </td>
                            <td>{customer.email}</td>
                            <td>{customer.mobile}</td>
                            <td>{customer.city}</td>
                            <td>{customer.state}</td>
                            <td>{formatDate(customer.created_at)}</td>
                            <td>{getStatusBadge(customer.status)}</td>
                            <td>
                              <div className="d-flex gap-2">

                                {/* Edit */}
                                <Link
                                  to={`/order-list-edit/${customer.user_id}`}
                                  className="btn btn-soft-primary btn-sm"
                                >
                                  <i className="fa-solid fa-pencil fs-18"></i>
                                </Link>

                                {/* Delete */}
                                <button className="btn btn-soft-danger btn-sm">
                                  <i className="fa-solid fa-trash fs-18"></i>
                                </button>

                                {/* Admin Actions */}
                                <div className="dropdown">
                                  <button
                                    className="btn btn-sm btn-primary dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    disabled={approvingId === customer.user_id || rejectingId === customer.user_id}
                                  >
                                    Action
                                  </button>

                                  <ul className="dropdown-menu">
  {customer.status !== "active" && (
    <li>
      <button
        className="dropdown-item text-success"
        onClick={() => updateUserStatus(customer.user_id, "active")}
      >
        <i className="fa-solid fa-check me-2"></i> Active
      </button>
    </li>
  )}

  {customer.status !== "inactive" && (
    <li>
      <button
        className="dropdown-item text-danger"
        onClick={() => updateUserStatus(customer.user_id, "inactive")}
      >
        <i className="fa-solid fa-times me-2"></i> Inactive
      </button>
    </li>
  )}
</ul>

                                </div>
                              </div>
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
                {/* end table-responsive */}
              </div>

              <div className="card-footer border-top">
                <nav aria-label="Page navigation example">
                  <ul className="pagination justify-content-end mb-0">
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        Previous
                      </a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link" href="javascript:void(0);">
                        1
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        2
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        3
                      </a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="javascript:void(0);">
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}

      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href="" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default CustomerList;